module.exports = __webpack_public_path__ + "static/w-3-dff9445807a0a404094c188db8c871b0.svg";